import { render, staticRenderFns } from "./MedicalStudiesComponent.vue?vue&type=template&id=1acfa21a"
import script from "./MedicalStudiesComponent.vue?vue&type=script&lang=js"
export * from "./MedicalStudiesComponent.vue?vue&type=script&lang=js"
import style0 from "./MedicalStudiesComponent.vue?vue&type=style&index=0&id=1acfa21a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports